import { Navigate, Route, Routes } from 'react-router-dom';

import '@/pages/auth/login.css';
import { HOST_MB } from '@/lib/constants';
import { useWhitelabelByHost } from '@/hooks/api/use-whitelabel';

import SmallSpinner from '@/components/shared/spinners/small-spinner';
import AccimotoReponse from '@/pages/accimoto/accimoto-reponse';

/**
 * Pages publiques du parcours Accimoto (`/accimoto/{sinistre}/…`), ouvertes depuis les liens signés
 * des mails, hors de l'espace connecté. Habillage de la page de connexion, à la marque de l'hôte.
 */
const AccimotoPage = () => {
    const whitelabel = useWhitelabelByHost();

    if (whitelabel.isPending) {
        return <SmallSpinner />;
    }

    document.title = `Prise en charge de votre véhicule | ${whitelabel.data?.name ?? ''} - Espace assuré`;

    return (
        <div id={'login'}>
            {HOST_MB === 43397 && (
                <header className="flex flex-wrap fixed top-0 left-0 w-full m-0 login-header-container" style={{ zIndex: 10 }}>
                    <div className="flex-[1_0_0%] shadow-lg px-12 py-2 bg-white text-center">
                        <img src={whitelabel.data?.logo_light_url} alt="" style={{ height: '3.5rem', width: 'auto' }} className={'inline-block'} />
                    </div>
                </header>
            )}
            <div className="flex flex-wrap m-0">
                <div className="p-0 rounded-start rounded-top rounded-medium login-picture-container hidden lg:block">
                    <img src="/images/login/image-login.jpg" alt="" className={'rounded-start rounded-top rounded-medium'} />
                </div>
                <main className="m-auto px-3 login-form-container" style={{ width: '46vw' }}>
                    <div className={'m-auto login-formulaire'} style={{ width: '40vw', maxWidth: 500 }}>
                        <Routes>
                            <Route path={'accepter'} element={<AccimotoReponse page="accepter" />} />
                            <Route path={'refuser'} element={<AccimotoReponse page="refuser" />} />
                            <Route path={'localisation-vehicule'} element={<AccimotoReponse page="localisation-vehicule" />} />
                            <Route path={'*'} element={<Navigate to="/login" replace />} />
                        </Routes>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default AccimotoPage;
